import api from "../../../services/api";

import helpers from "../../../shared/fleetbox-helpers";

import horizontalTable from "./horizontalTable.vue";
import mapPoi from "./map.vue";

import { Marker, Polyline } from "../../../domain/poi";
import { bus } from "../../../main";

export default {
	components: {
		horizontalTable,
		mapPoi
	},
	data: function() {
		return {
			loading: false,
			query: {
				page: 0,
				pageSize: 100000
			},

			//Data
			poiItems: [], // rendering_type: unknown, marker, polygon, polyline, circle
			poiCategories: [],

			//Filter element to show
			showTableMapPopover: false,
			mapTableVisualizationSelected: "../../../assets/m_ht.png",

			showMap: true,
			showHorizontalTable: true,

			//Filter location
			lastSearch: "",
			search: "",
			pointToCenter: null,

			//Data that change
			poiItemToEdit: null,
			poiCategoriesSelected: null,
			poiName: "",
			poiAddress: "",
			poiRadius: 100,
			poiCoordinates: { lat: null, lng: null },

			//state change
			isInEditMode: false,
			typeOfPoi: "",
			isNewOrEdit: false //true: new / false: edit
		};
	},

	watch: {
		poiCoordinates: function(newValue, oldValue) {
			if (newValue && newValue.lat && newValue.lng) {
				var self = this;
				//get address from geo point

				var params = {
					latitude: newValue.lat,
					longitude: newValue.lng
				};

				api.getReverseGeocoding(params).then(res => {
					if (res && res.length > 0) {
						var newAddress = self._.find(res, function(item) {
							return (
								self._.find(item.types, function(x) {
									return x === "streetAddress";
								}) != null
							);
						});

						if (!newAddress) {
							newAddress = res[0];
						}

						if (newAddress && newAddress.formattedAddress) {
							self.poiAddress = newAddress.formattedAddress;
						}
					}
				});
			} else {
				this.poiAddress = "";
			}
		},
		poiRadius: function(newValue) {
			if (this.poiItemToEdit && this.poiItemToEdit.location.rendering_type == "circle") {
				this.poiItemToEdit.radius = newValue;
				bus.$emit("item-radius-change", this.poiItemToEdit);
			}
		},
		showTableMapPopover() {
			var self = this;
			self.$root.$emit("bv::hide::tooltip");
			setTimeout(() => {
				self.$root.$emit("bv::hide::tooltip");
			}, 700);
		}
	},

	created() {
		var self = this;

		var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, false);
		this.mapTableVisualizationSelected = `../../../${icon}`;

		self.getPoiCategories();
		bus.$emit("show-spinner-loading");
	},
	beforeDestroy() {},
	methods: {
		showMaptable(v) {
			if (v == "ht") {
				this.showHorizontalTable = !this.showHorizontalTable;
			} else if (v == "m") {
				this.showMap = !this.showMap;
			}

			if (!this.showHorizontalTable && !this.showMap) this.showMap = this.showHorizontalTable = true;

			var icon = helpers.getIconForVisualizationType(this.showMap, this.showHorizontalTable, false);
			this.mapTableVisualizationSelected = `../../../${icon}`;

			this.onCloseShowTableMapPopover();
		},
		onCloseShowTableMapPopover() {
			this.showTableMapPopover = false;
		},
		onPoiInEditDataChange() {
			if (this.poiItemToEdit) {
				this.poiItemToEdit.edited = true;
			}
		},
		searchClick() {
			if (this.search) {
				var self = this;
				var params = {
					address: this.search
				};

				api.getReverseGeocoding(params).then(res => {
					if (res && res.length > 0) {
						var newPoint = self._.find(res, function(item) {
							return item.coordinates && item.coordinates.lat && item.coordinates.lon != null;
						});

						if (newPoint) {
							self.pointToCenter = {
								lat: newPoint.coordinates.lat,
								lng: newPoint.coordinates.lon
							};

							self.lastSearch = self.search;
						}
					}
				});
			}
		},
		switchEditMode(isInEditMode) {
			this.isInEditMode = isInEditMode;
			this.onEditModeChange();
			if (!isInEditMode) {
				this.closeEditMode();
			}
		},
		onAddItemClick(typeOfItem) {
			switch (typeOfItem) {
				case "marker":
					this.addPoiMarker();
					break;
				case "polygon":
					this.addPoiPolygon();
					break;
				case "area":
					this.addPoiArea();
					break;

				default:
					break;
			}

			bus.$emit("add-new-item");
		},
		onEditRowItem(e) {
			if (e) {
				this.onEditModeChange();
				var poiItemToEdit = this.poiItems.find(poi => {
					return poi.id == e.id;
				});

				poiItemToEdit.visible = true;
				poiItemToEdit.draggable = true;

				var rt = e.location.rendering_type;

				this.poiItemToEdit = poiItemToEdit;
				this.poiCategoriesSelected = poiItemToEdit.poi_category_id ? _.toString(poiItemToEdit.poi_category_id) : null;
				this.poiName = poiItemToEdit.name;
				this.poiAddress = poiItemToEdit.address || "";

				switch (rt) {
					case "marker":
						this.typeOfPoi = "marker";
						this.poiCoordinates = { lat: poiItemToEdit.location.points[0].lat, lng: poiItemToEdit.location.points[0].lon };
						break;

					case "circle":
						this.typeOfPoi = "area";
						poiItemToEdit.editable = true;
						this.poiCoordinates = { lat: poiItemToEdit.location.points[0].lat, lng: poiItemToEdit.location.points[0].lon };
						this.poiRadius = poiItemToEdit.radius;

						break;

					case "polygon":
						this.typeOfPoi = "polygon";
						this.poiCoordinates = { lat: poiItemToEdit.location.points[0].lat, lng: poiItemToEdit.location.points[0].lon };
						poiItemToEdit.editable = true;

						break;

					default:
						poiItemToEdit.editable = true;
						break;
				}

				this.isInEditMode = true;
				this.isNewOrEdit = false;
			}
		},
		removeItem(e) {
			var self = this;
			if (this.poiItemToEdit && this.poiItemToEdit.id == e.id) {
				this.poiCategoriesSelected = this.poiCategories.length > 0 ? _.toString(this.poiCategories[0].id) : null;
				this.poiName = "";
				this.poiAddress = "";
				this.poiRadius = 100;
				this.poiCoordinates = { lat: null, lng: null };
				this.typeOfPoi = "marker";
				this.isNewOrEdit = true;
				this.poiItemToEdit.visible = false;
				bus.$emit("add-new-item");
			}

			if (e.id <= 0) {
				var indexItemToDelete = this.poiItems.findIndex(item => {
					return item.id == e.id;
				});

				if (indexItemToDelete >= 0) {
					this.poiItems.splice(indexItemToDelete, 1);
				}
				self.closeEditMode();
			} else {
				/* client delete */
				var poiItem = this.poiItems.find(item => {
					return item.id == e.id;
				});

				poiItem.deleted = true;
				/* client delete */

				/* server delete */
				api.deletePoi(e.id)
					.then(res => {
						if (res) {
							self.closeEditMode();
							poiItem.deleted = true;
						} else {
							poiItem.deleted = false;
						}
					})
					.catch(err => {
						poiItem.deleted = false;
					});
			}
		},
		onSubmit() {
			//save poi configurations (new or update)
			var self = this;
			var poiToSave = this.poiItems.find(poi => {
				return poi.id <= 0 || poi.edited == true;
			});
			if (poiToSave) {
				var data = {
					id: poiToSave.id < 0 ? 0 : poiToSave.id,
					name: this.poiName,
					location: {
						city: poiToSave.location.city,
						region: poiToSave.location.region,
						zip_code: poiToSave.location.zip_code,
						country_code: poiToSave.location.country_code,
						rendering_type: poiToSave.location.rendering_type,
						points: poiToSave.location.points
					},
					poi_category_id: parseInt(this.poiCategoriesSelected)
				};

				if (this.poiAddress) {
					data.location.address = this.poiAddress;
				}

				if (poiToSave.location.rendering_type == "circle") {
					data.radius = poiToSave.radius;
				}

				bus.$emit("show-spinner-loading");
				api.postPoisData(data).then(res => {
					self.closeEditMode();
				})
				.finally(() => {
					bus.$emit("hide-spinner-loading");
				});
			}
		},
		onEditModeChange() {
			if (this.isInEditMode) {
				this.poiItems.forEach(function(item) {
					item.visible = false;
					item.edited = false;
				});
			} else {
				this.poiItems.forEach(function(item) {
					item.visible = true;
					item.editable = false;
					item.draggable = false;
					item.deleted = false;
					item.edited = false;
				});
			}
		},
		addPoiMarker() {
			if (this.isInEditMode) {
				this.removeNewItem();
				this.typeOfPoi = "marker";
				this.isInEditMode = true;
				this.isNewOrEdit = true;
				this.onEditModeChange();
			}
		},

		addPoiPolygon() {
			if (this.isInEditMode) {
				this.removeNewItem();
				this.typeOfPoi = "polygon";
				this.isInEditMode = true;
				this.isNewOrEdit = true;
				this.onEditModeChange();
			}
		},
		addPoiArea() {
			if (this.isInEditMode) {
				this.removeNewItem();
				this.typeOfPoi = "area";
				this.isInEditMode = true;
				this.isNewOrEdit = true;
				this.onEditModeChange();
			}
		},
		removeNewItem() {
			var indexItemToDelete = this.poiItems.findIndex(item => {
				return item.id <= 0;
			});

			if (indexItemToDelete >= 0) {
				this.poiItems.splice(indexItemToDelete, 1);
			}
		},
		closeEditMode() {
			this.isInEditMode = false;
			this.isNewOrEdit = false;
			this.typeOfPoi = "";

			this.poiCategoriesSelected = this.poiCategories.length > 0 ? _.toString(this.poiCategories[0].id) : null;
			this.poiName = "";
			this.poiAddress = "";
			this.poiRadius = 100;
			this.poiCoordinates = { lat: null, lng: null };
			this.poiItemToEdit = null;

			var poiItemsToRemove = this.poiItems
				.filter(function(item) {
					return item.id <= 0;
				})
				.map(m => {
					return m.id;
				});

			for (var i = 0; i < poiItemsToRemove.length; i++) {
				var index = this.poiItems.findIndex(p => {
					p.id == poiItemsToRemove[i];
				});

				if (index >= 0) {
					this.poiItems.splice(index, 1);
				}
			}

			this.getData();
		},
		getPoiCategories() {
			var self = this;
			api.getPoiCategoriesData()
				.then(res => {
					self.poiCategories = res.map(function(item) {
						return {
							id: item.id,
							name: item.name,
							description: item.description,
							background_color: item.background_color || null,
							icon_image: item.icon_image
						};
					});

					if (self.poiCategories.length > 0) {
						self.poiCategoriesSelected = _.toString(self.poiCategories[0].id);
					}

					self.getData();
				})
				.finally(() => {
					bus.$emit("hide-spinner-loading");
				});
		},
		getData: function() {
			var self = this;
			this.loading = true;

			api.getPoisData(this.query).then(res => {
				self.loading = false;
				self.poiItems = res.items.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						poi_category_id: item.poi_category_id,
						poi_category_name: self.getPoiDescription(item.poi_category_id),
						poi_category_icon_image: self.getPoiIconImgae(item.poi_category_id),
						poi_category_fill_color: self.getPoiFillColor(item.poi_category_id),
						radius: item.radius,
						location: item.location,
						geofences: item.geofences,

						visible: true,
						editable: false,
						draggable: false,
						edited: false,
						deleted: false,
						selected: false
					};
				});

				self.poiItemToEdit = null;

				// self.tableItems = this.poiItems.map(function(item) {
				// 	return {
				// 		id: item.id,
				// 		rendering_type: item.rendering_type,
				// 		name: item.name,
				// 		address: item.location.address,
				// 		city: item.location.city,
				// 		poi_category_id: item.poi_category_id,
				// 		poi_category_name: item.poi_category_name,
				//		poi_category_icon_image: self.getPoiIconImgae(item.poi_category_id),
				//		poi_category_fill_color: self.getPoiFillColor(item.poi_category_id),
				// 		location: item.location,
				// 		visible: item.visible
				// 	};
				// });

				//self.itemsTable = self.itemsMaps;

				self.total = res.totalCount;

				// self.$nextTick(function() {
				// 	self.displayAllMarkers();
				// });
			});
		},
		getPoiDescription(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.name;
			}

			return poiId;
		},
		getPoiFillColor(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.background_color;
			}

			return "#000";
		},
		getPoiIconImgae(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi && poi.icon_image) return poi.icon_image;
				else return "/assets/map/icon/blank.png";
			}

			return null;
		},
		// displayAllMarkers: function() {
		// 	var self = this;

		// 	self.itemsMaps.forEach(function(item, index) {
		// 		var m = new Marker();
		// 		m.id = item.id;
		// 		m.position.lat = item.location.points[0].lat;
		// 		m.position.lng = item.location.points[0].lon;
		// 		m.title = item.name;

		// 		self.markers.push(m);
		// 	});
		// },
		addNewMarker: function(m) {
			if (m) {
				if (this.poiName) {
					m.title = this.poiName;
				}
				var newItem = {
					id: m.id,
					name: this.poiName ? this.poiName : m.title,
					poi_category_id: this.poiCategoriesSelected,
					poi_category_name: this.getPoiDescription(this.poiCategoriesSelected),
					poi_category_icon_image: this.getPoiIconImgae(this.poiCategoriesSelected),
					poi_category_fill_color: this.getPoiFillColor(this.poiCategoriesSelected),
					location: {
						address: "",
						city: "",
						country_code: "",
						points: [
							{
								lat: m.position.lat,
								lon: m.position.lng
							}
						],
						region: "",
						rendering_type: "marker",
						zip_code: ""
					},

					visible: true,
					draggable: true,
					deleted: false,
					selected: false
				};

				this.poiAddress = "";
				this.poiCoordinates = {
					lat: m.position.lat,
					lng: m.position.lng
				};

				this.poiItemToEdit = newItem;
				this.poiItems.push(newItem);
			}
		},
		editMarker(data) {
			var id = data.id;
			var m = this.poiItems.find(mr => {
				return mr.id == id;
			});

			if (m) {
				var e = data.data;
				m.location.address = "";
				m.location.points[0].lat = e.latLng.lat();
				m.location.points[0].lon = e.latLng.lng();

				this.poiAddress = "";
				this.poiCoordinates = {
					lat: e.latLng.lat(),
					lng: e.latLng.lng()
				};
			}

			m.edited = true;
		},
		addNewPolygon: function(p) {
			if (p) {
				if (this.poiName) {
					p.title = this.poiName;
				}
				var newItem = {
					id: p.id,
					name: this.poiName,
					poi_category_id: this.poiCategoriesSelected,
					poi_category_name: this.getPoiDescription(this.poiCategoriesSelected),
					poi_category_icon_image: this.getPoiIconImgae(this.poiCategoriesSelected),
					poi_category_fill_color: this.getPoiFillColor(this.poiCategoriesSelected),
					location: {
						address: "",
						city: "",
						country_code: "",
						points: p.path,
						region: "",
						rendering_type: "polygon",
						zip_code: ""
					},

					visible: true,
					draggable: true,
					editable: true,
					deleted: false,
					selected: false
				};

				this.poiAddress = "";
				this.poiCoordinates = {
					lat: p.path[0].lat,
					lng: p.path[0].lon
				};

				this.poiItemToEdit = newItem;
				this.poiItems.push(newItem);
			}
		},
		editPolygon(data) {
			var id = data.id;
			var p = this.poiItems.find(pol => {
				return pol.id == id;
			});

			if (p) {
				var newPath = data.path.map(item => {
					return {
						lat: item.lat,
						lon: item.lng
					};
				});

				p.location.points = newPath;
				p.edited = true;
			}
		},
		editPolygonEnd(data) {
			var id = data.id;
			var p = this.poiItems.find(pol => {
				return pol.id == id;
			});

			if (p) {
				this.poiAddress = "";
				this.poiCoordinates = {
					lat: p.location.points[0].lat,
					lng: p.location.points[0].lon
				};
			}
		},
		addNewArea(a) {
			if (a) {
				if (this.poiName) {
					a.title = this.poiName;
				}
				var newItem = {
					id: a.id,
					name: this.poiName,
					poi_category_id: this.poiCategoriesSelected,
					poi_category_name: this.getPoiDescription(this.poiCategoriesSelected),
					poi_category_icon_image: this.getPoiIconImgae(this.poiCategoriesSelected),
					poi_category_fill_color: this.getPoiFillColor(this.poiCategoriesSelected),
					radius: a.radius,
					location: {
						address: "",
						city: "",
						country_code: "",
						points: a.center,
						region: "",
						rendering_type: "circle",
						zip_code: ""
					},

					visible: true,
					draggable: true,
					editable: true,
					deleted: false,
					selected: false
				};

				this.poiCoordinates = {
					lat: a.center[0].lat,
					lng: a.center[0].lon
				};
				this.poiRadius = a.radius;

				this.poiItemToEdit = newItem;
				this.poiItems.push(newItem);
			}
		},
		editArea(data) {
			var id = data.id;
			var c = this.poiItems.find(pol => {
				return pol.id == id;
			});

			if (data.property == "center") {
				c.location.points = data.center;
			} else if (data.property == "radius") {
				c.radius = data.radius;
				this.poiRadius = data.radius;
			}

			c.edited = true;
		},
		editAreaDragEnd(data) {
			var id = data.id;
			var a = this.poiItems.find(pol => {
				return pol.id == id;
			});

			if (a) {
				this.poiAddress = "";
				this.poiCoordinates = {
					lat: a.location.points[0].lat,
					lng: a.location.points[0].lon
				};
			}
		},
		onMarkerClick: function(e) {
			bus.$emit("marker-click", e);
		},

		onSelectedRow: function(e) {
			bus.$emit("on-selected-row", e);
		}
	},
	computed: {
		categoriesFilter() {
			return this.poiCategories.map(function(item) {
				return {
					id: item.name,
					value: item.name
				};
			});
		},
		poiCoordinateLat() {
			if (this.poiCoordinates.lat) {
				return this.poiCoordinates.lat.toFixed(8);
			}

			return "";
		},
		poiCoordinateLng() {
			if (this.poiCoordinates.lng) {
				return this.poiCoordinates.lng.toFixed(8);
			}

			return "";
		},
		mapClass: function() {
			if (this.showHorizontalTable) {
				return "mapwithHorizontalTable";
			}

			return " mapNoTables";
		},
		containerMapClass: function() {
			if (this.isInEditMode && this.typeOfPoi) {
				return "col-lg-8 ";
			}
			return "col-lg-12";
		},
		mapItems: function() {
			var itemsToShowOnMap = this.poiItems.filter(function(item) {
				return item.visible == true;
			});

			return itemsToShowOnMap;
		},
		tableItems: function() {
			return this.poiItems.filter(item => {
				return item.deleted == false;
			});
			// return this.poiItems.map(function(item) {
			// 	return {
			// 		id: item.id,
			// 		rendering_type: item.rendering_type,
			// 		name: item.name,
			// 		address: item.location.address,
			// 		city: item.location.city,
			// 		poi_category_id: item.poi_category_id,
			// 		poi_category_name: item.poi_category_name,
			// 		location: item.location,
			// 		visible: item.visible
			// 	};
			// });
		},
		horizontalTableClass: function() {
			if (!this.showMap) {
				return " horizontal-table-without-map";
			}

			return "";
		},
		getStateMIcon() {
			return `../../../${helpers.getStateMIcon(this.showMap)}`;
		},
		getStateHTIcon() {
			return `../../../${helpers.getStateHTIcon(this.showHorizontalTable)}`;
		}
	}
};
